/* eslint-disable */
import type { ResponseContext } from "./ResponseContextProto.pb";
import type { Instrument, Transfer } from "./api.pb";
import type { IssuedCard } from "./common.pb";
import type { ScenarioPlan } from "./scenarios.pb";
import type { StatusResult } from "./status_result.pb";
import type { UiPayment } from "./ui/payment.pb";

export interface SetPasscodeResponse {
  response_context?: ResponseContext;
  status?: SetPasscodeResponseStatus;
  /**
   * A message to display to the customer. Can be non-null for either success or failure.
   * Deprecated in v2.18 in favor of ResponseContext.
   *
   * @deprecated
   */
  message?: string;
  /** The passcode token corresponding to the new passcode. Null if request was not successful. */
  passcode_token?: string;
  /**
   * ScenarioPlan contains info about additional screens/blockers to complete the scenario.
   * Deprecated in v2.18 in favor of ResponseContext.
   *
   * @deprecated
   */
  scenario_plan?: ScenarioPlan;
  /**
   * The issued card. Included if the client scenario matches *_ISSUED_CARD.
   * Deprecated in v2.18 in favor of ResponseContext.
   *
   * @deprecated
   */
  issued_card?: IssuedCard;
  /**
   * The updated payments. Deprecated in v2.18 in favor of ResponseContext.
   *
   * @deprecated
   */
  payments?: UiPayment[];
  /**
   * The updated transfer. Deprecated in v2.18 in favor of ResponseContext.
   *
   * @deprecated
   */
  transfer?: Transfer;
  /**
   * The data to display on the payment flow's result screen.
   * Deprecated in v2.18 in favor of ResponseContext.
   *
   * @deprecated
   */
  status_result?: StatusResult;
  /**
   * The customer's updated balance instrument.
   * Deprecated in v2.18 in favor of ResponseContext.
   *
   * @deprecated
   */
  balance_instrument?: Instrument;
}

export enum SetPasscodeResponseStatus {
  INVALID = "INVALID",
  SUCCESS = "SUCCESS",
  /**
   * CONCURRENT_MODIFICATION - Concurrent modification is returned when a request requires an old passcode and one wasn't
   * provided, or vice versa. It also occurs when the old instrument token doesn't match.
   * Apps should refresh profile then begin the flow again.
   */
  CONCURRENT_MODIFICATION = "CONCURRENT_MODIFICATION",
  /**
   * RETRYABLE_FAILURE - A retryable failure that causes the app to show the message then present the flow again.
   * e.g. The user provided an invalid old passcode.
   */
  RETRYABLE_FAILURE = "RETRYABLE_FAILURE",
  /**
   * NONRETRYABLE_FAILURE - A non-retryable failure that causes the app to show the message then exit the flow.
   * e.g. The user provided an invalid old passcode 3 times and is locked out for 24 hours.
   */
  NONRETRYABLE_FAILURE = "NONRETRYABLE_FAILURE",
}
